import { render, staticRenderFns } from "./NewsInner.vue?vue&type=template&id=4fc59fbe&"
import script from "./NewsInner.vue?vue&type=script&lang=js&"
export * from "./NewsInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports